<ion-app>
  <ion-router-outlet></ion-router-outlet>

  <!-- Update Modal -->
  <ion-modal [isOpen]="showUpdateModal" backdropDismiss="false" class="force-update-modal">
    <ng-template>
      <div class="popup-wrapper">
        <div class="popup-container">
          <div class="popup-header">
            <ion-img [src]="'assets/icons/update-icon.svg'" alt="Update icon" class="update-icon"></ion-img>
            <div class="popup-title f-20 fw-600">Update Available</div>
          </div>
          <div class="popup-message f-16 fw-400">For better experience please update your Oye Creator's App</div>
          <div class="update-btn-align">
            @if (laterButton) {<ion-button fill="clear" class="nocaps later-btn f-16 fw-600" (click)="closeUpdateModal()">Later</ion-button>}
            <ion-button class="nocaps update-btn f-16 fw-600" (click)="updateApp()">Update Now</ion-button>
          </div>
        </div>
      </div>
    </ng-template>
  </ion-modal>

</ion-app>
